import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const key = 'edit-comment'

    if (1 === selectedNodes.size) {
        const [node] = selectedNodes

        return {
            key,
            label: node.comment ? '编辑批注' : '添加批注',
            onClick: () => map.startEditNodeComment(node),
        }
    }
    else {
        return {
            disabled: true,
            key,
            label: '添加批注',
        }
    }
}
